// extracted by mini-css-extract-plugin
export var label = "_in-2";
export var slideContainer = "_in-0";
export var slider = "_in-1";